import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";
import { AsaasPaymentResponse } from "../components/Modals/PagamentoModal/types.ts";
import { CreditCardData } from "../components/Modals/PagamentoModal/CreditCardForm.tsx";

const signPlanASAAS = async (
  idPlanoModelo: string,
  ciclo: string,
  billingType: string = "PIX",
  creditCard?: CreditCardData
): Promise<AsaasPaymentResponse> => {
  const body: any = {
    planoModeloId: idPlanoModelo,
    billingType: billingType,
    ciclo: ciclo,
  };
  if (creditCard) {
    body.creditCard = creditCard;
  }

  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/asaas/assinatura",
    data: body,
  });

  return result?.data as AsaasPaymentResponse;
};

const cancelarAssinatura = async (): Promise<void> => {
  await handleService({
    method: MethodsEnum.DELETE,
    endpoint: "/asaas/assinatura/cancelar",
  });
};

// Cancela no ASAAS uma assinatura ainda pendente de pagamento (cliente desistiu
// antes de pagar o PIX/Boleto). Diferente de cancelarAssinatura, não exige plano
// ativo/pago — é usada quando o cliente fecha o modal de pagamento sem concluir.
const cancelarAssinaturaPendente = async (): Promise<void> => {
  await handleService({
    method: MethodsEnum.DELETE,
    endpoint: "/asaas/assinatura/cancelar-pendente",
  });
};

const getMeuPlano = async (): Promise<any> => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/plano/meu-plano",
  });
  return result?.data || null;
};

const alterarPlano = async (
  planoModeloId: string,
  ciclo: string = "MONTHLY",
  billingType?: string
): Promise<AsaasPaymentResponse> => {
  const body: any = { planoModeloId, ciclo };
  if (billingType) body.billingType = billingType;

  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/asaas/assinatura/alterar-plano",
    data: body,
  });

  return result?.data as AsaasPaymentResponse;
};

const cancelarAgendamentoTroca = async (): Promise<void> => {
  await handleService({
    method: MethodsEnum.DELETE,
    endpoint: "/plano/agendamento",
  });
};

const pagamentoService = { signPlanASAAS, cancelarAssinatura, cancelarAssinaturaPendente, getMeuPlano, alterarPlano, cancelarAgendamentoTroca };

export default pagamentoService;
